export default {
  path: '/join-info',
  meta: {
    title: '入驻信息',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/join-info`),
}



// WEBPACK FOOTER //
// ./src/views/JoinInfo/router.js